var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoReviewsImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 250,
  height: 250,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M91.001 44A81 81 0 1 0 91 206a81 81 0 0 0 .002-162m0 145.774a64.78 64.78 0 0 1-59.842-39.987 64.773 64.773 0 1 1 119.687.002 64.76 64.76 0 0 1-35.056 35.058 64.8 64.8 0 0 1-24.789 4.931z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M25 139.985 135.25 205 205 162.78 93.625 99z",
  opacity: 0.15
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M132.952 204 245 169.163 187.599 99 87 127.405z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M135.608 204 135 190.017l48.351-31.78L205 151l-.158 11.405z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  d: "M135.608 204 135 190.017l48.351-31.78L205 151l-.158 11.405z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M135.608 204 135 190.017l48.351-31.78L205 151l-.158 11.405z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  d: "M26 139.428 26.16 125l106.979 61.487 2.724 4.81L136 204z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#g)",
  d: "M26 127.097V117l107.378 55.932 2.594 8.055L136 191z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#h)",
  d: "m136.028 191-.028-9.978 47.667-36.292L205 141v9.61z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m136.028 191-.028-9.978 47.667-36.292L205 141v9.61z",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#i)",
  d: "M26 117.519 135.352 181 205 141.155 95.65 77z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#j)",
  d: "M26 117.519 135.352 181 205 141.155 95.65 77z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "m191.098 135.873-4.576 2.774.141-.247-90.012-51.901 7.413-4.385L102.167 81 33 121.908l1.908 1.107 8.14-4.814 89.656 51.695-4.943 2.996 1.908 1.108 11.49-6.964-1.897-1.114-4.678 2.834-89.631-51.681 49.8-29.454 90.171 51.993-5.322 3.226 1.908 1.108 11.49-6.964z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#k)",
  d: "m205 141.436-27.851-16.43c.241-.333-29.319 12.903-29.319 12.903l-.83 9.643 3.338 4.448 40.135-2.242z",
  opacity: 0.79
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M148.047 155 162 146.522 148.088 138 134 146.568z",
  opacity: 0.14
}), /*#__PURE__*/React.createElement("path", {
  fill: "#93287D",
  d: "M148.792 154 134 145.63V144l10.77 3.886 4.022 4.324.208 1.332z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#752265",
  d: "M148 152.218V154l13.89-8.304L162 144l-8.668 3.435z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#l)",
  d: "M148.047 152 162 144.021 148.088 136 134 144.064z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#m)",
  d: "M149.125 125.587c-.034-.327-.544-.587-1.17-.587s-1.142.263-1.171.593c0 0-5.784 18.33-5.784 18.697 0 2.049 3.134 3.71 7 3.71s7-1.657 7-3.71c-.002-.47-5.875-18.703-5.875-18.703"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CC429A",
  d: "M148.5 126c.828 0 1.5-.224 1.5-.5s-.672-.5-1.5-.5-1.5.224-1.5.5.672.5 1.5.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M153.5 137q.008.149-.007.298c0 1.507-2.074 2.728-5.048 2.728s-5.123-.974-5.123-2.481q.003-.185.054-.365l-1.279 3.978a1.7 1.7 0 0 0-.097.564c0 1.81 2.893 3.278 6.463 3.278s6.537-1.597 6.537-3.408c-.132-.372-1.5-4.592-1.5-4.592m-2.722-7.955q.006.101 0 .202c0 1.025-.759 1.605-2.359 1.605s-2.268-.58-2.268-1.605q.002-.125.029-.247l-1.128 4.389a1.4 1.4 0 0 0-.052.383c0 1.231 1.558 2.228 3.478 2.228s3.522-1.086 3.522-2.316c-.072-.253-1.222-4.639-1.222-4.639"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M149.125 125.587c-.034-.327-.544-.587-1.17-.587s-1.142.263-1.171.593c0 0-5.784 18.33-5.784 18.697 0 2.049 3.134 3.71 7 3.71s7-1.657 7-3.71c-.002-.47-5.875-18.703-5.875-18.703",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#n)",
  d: "M148.32 125q-.16 0-.32.022c.495 3.552 1.014 19.194 1.138 22.978 3.853-.188 6.862-1.769 6.862-3.695 0-.469-6.402-18.718-6.402-18.718-.041-.327-.595-.587-1.278-.587",
  opacity: 0.9
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 14.698,
  x2: 168.274,
  y1: 142.172,
  y2: 107.504,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7DFFB4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#44E4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 123.024,
  x2: 179.946,
  y1: 178.905,
  y2: 87.011,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.122
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.663,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 200.17,
  x2: 141.623,
  y1: 157.413,
  y2: 216.928,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE33CB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F65B6F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 138.57,
  x2: 183.167,
  y1: 193.082,
  y2: 148.669,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.097,
  stopColor: "#F65B6F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.851,
  stopColor: "#FE33CB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 131.49,
  x2: 67.906,
  y1: 193.256,
  y2: 122.922,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F65B6F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE33CB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 140.51,
  x2: 62.874,
  y1: 185.154,
  y2: 92.364,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.099,
  stopColor: "#715CCF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.959,
  stopColor: "#50C5F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: 121.234,
  x2: 202.698,
  y1: 192.9,
  y2: 96.885,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.197,
  stopColor: "#715CCF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#50C5F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 28.327,
  x2: 175.773,
  y1: 112.256,
  y2: 196.16,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.075,
  stopColor: "#50C5F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.813,
  stopColor: "#715CCF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: -22.509,
  x2: 129.681,
  y1: 102.48,
  y2: 189.192,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.365,
  stopOpacity: 0.302
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.819,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: 147,
  x2: 205,
  y1: 138.5,
  y2: 138.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.182,
  stopOpacity: 0.251
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.682,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  x1: 134,
  x2: 162,
  y1: 144,
  y2: 144,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE33CB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F65B6F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "m",
  x1: 156.96,
  x2: 140.044,
  y1: 147.149,
  y2: 140.93,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE33CB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.734,
  stopColor: "#F65B6F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "n",
  x1: 158.48,
  x2: 144.986,
  y1: 135.304,
  y2: 135.507,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.079
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.814,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 258,
  height: 258,
  x: -4,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_410_3456"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_410_3456",
  result: "shape"
})))));
export default SvgNoReviewsImage;